/**
 * By default, the global error handler in SWRConfigProvider will catch and handle all 4xx or 5xx responses.
 * This configuration lets each useBackend() or useSWR() call handle errors locally instead.
 */
export const handleSWRErrorLocally = {
  onError: () => {},
};
